(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3319],{

/***/ 54931:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicine-dictionary",
      function () {
        return __webpack_require__(59075);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ medicine_dictionary; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/constants/zIndex.ts
var zIndex = __webpack_require__(31591);
// EXTERNAL MODULE: ./src/design-components/organisms/dnsearch-bar/index.tsx
var dnsearch_bar = __webpack_require__(48283);
// EXTERNAL MODULE: ./src/components/common/link-tag/index.tsx
var link_tag = __webpack_require__(1967);
// EXTERNAL MODULE: ./src/entities/medicine-dictionary/ui/MedicineDictionary.tsx
var MedicineDictionary = __webpack_require__(7265);
// EXTERNAL MODULE: ./src/entities/medicine-dictionary/util/index.ts
var util = __webpack_require__(68534);
// EXTERNAL MODULE: ./src/hooks/medicine-dictionary/usePopularMedicineDictionaryItems.ts
var usePopularMedicineDictionaryItems = __webpack_require__(51196);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/hook/useSearchPopularMedicineDictionaryViewModel.ts



var useSearchPopularMedicineDictionaryViewModel = function() {
    var router = (0,useCustomRouter/* default */.Z)().router;
    var popularMedicineDictionaryItems = (0,usePopularMedicineDictionaryItems/* default */.Z)().popularMedicineDictionaryItems;
    var items = (popularMedicineDictionaryItems === null || popularMedicineDictionaryItems === void 0 ? void 0 : popularMedicineDictionaryItems.slice(0, 6)) || [];
    var onClickMedicineDictionary = function(medicineDictionary) {
        return function() {
            router.push((0,util/* createMedicineDictionaryDetailUrl */.at)(medicineDictionary));
        };
    };
    return {
        popularMedicineDictionaryItems: items,
        onClickMedicineDictionary: onClickMedicineDictionary
    };
};
/* harmony default export */ var hook_useSearchPopularMedicineDictionaryViewModel = (useSearchPopularMedicineDictionaryViewModel);

;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/SearchPopularMedicineDictionary.tsx





var SearchPopularMedicineDictionary = function() {
    var viewModel = hook_useSearchPopularMedicineDictionaryViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-[24px] pt-[24px] pb-[32px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "typography-ui-20sb mb-4 text-gray-700 ",
                children: "많이 검색된 약품"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1 gap-[28px] md:grid-cols-2",
                suppressHydrationWarning: true,
                children: viewModel.popularMedicineDictionaryItems.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
                        href: (0,util/* createMedicineDictionaryDetailUrl */.at)(item),
                        onClickNavigateToScreen: viewModel.onClickMedicineDictionary(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicineDictionary/* default */.Z, {
                            title: item.getBasicInfoName(),
                            description: item.getPharmaceuticalEffectLiteracy(),
                            summary: item.getWholeSummary(),
                            image: item.getRepresentativeImage(),
                            imageAlt: item.getSimplifiedName()
                        })
                    }, item.getPublicId());
                })
            })
        ]
    });
};
/* harmony default export */ var ui_SearchPopularMedicineDictionary = (SearchPopularMedicineDictionary);

// EXTERNAL MODULE: ./src/components/common/PaginationComponent.tsx + 3 modules
var PaginationComponent = __webpack_require__(29697);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/SearchTotalMedicineDictionary.tsx





var SearchTotalMedicineDictionary = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-[16px] px-[24px] pt-[32px] pb-[80px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "typography-ui-20sb mb-4 text-gray-700 ",
                        children: "전체 약품"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-1 gap-[28px] md:grid-cols-2",
                        suppressHydrationWarning: true,
                        children: props.viewModel.medicineDictionaryItems.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
                                href: "".concat((0,util/* createMedicineDictionaryDetailUrl */.at)(item)),
                                onClickNavigateToScreen: props.viewModel.onClickMedicineDictionary(item),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicineDictionary/* default */.Z, {
                                    title: item.getBasicInfoName(),
                                    description: item.getPharmaceuticalEffectLiteracy(),
                                    summary: item.getWholeSummary(),
                                    image: item.getRepresentativeImage(),
                                    imageAlt: item.getSimplifiedName()
                                })
                            }, item.getPublicId());
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationComponent/* default */.Z, {
                baseUrl: props.viewModel.paginationBaseUrl,
                queries: props.viewModel.queries,
                currentPage: props.viewModel.currentPage,
                perPage: 5,
                totalPage: props.viewModel.totalPage,
                scroll: false
            })
        ]
    });
};
/* harmony default export */ var ui_SearchTotalMedicineDictionary = (SearchTotalMedicineDictionary);

// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/components/templates/medicine-dictionary/MedicineDictionaryTemplate.tsx









var MedicineDictionaryTemplate = function(props) {
    var shouldShowBreadCrumbs = props.client.clientType === app/* ClientType.WEB */.B.WEB;
    var topPosition = props.client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB ? "60px" : "0px";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                suppressHydrationWarning: true,
                children: shouldShowBreadCrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                        visible: true,
                        name: "의약품 사전",
                        type: "medicine_dictionary",
                        path: "".concat(common/* ROUTES.MEDICINE_DICTIONARY.HOME.path */.Z6.MEDICINE_DICTIONARY.HOME.path)
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "typography-ui-22sb px-[24px] py-[16px] text-gray-900",
                children: "의약품 사전"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-[24px] py-[16px]",
                style: {
                    zIndex: zIndex/* zIndex.AppHeader */.W.AppHeader,
                    top: topPosition
                },
                suppressHydrationWarning: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dnsearch_bar/* default */.Z, {
                    value: props.viewModel.keyword,
                    placeholder: "약 이름 또는 성분 등",
                    shouldShowResetButton: !!props.viewModel.keyword,
                    searchInputRef: props.viewModel.searchInputRef,
                    onSubmit: props.viewModel.handleSubmit,
                    onReset: props.viewModel.handleResetSearchKeyword,
                    onChange: props.viewModel.handleChangeSearchKeyword
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SearchPopularMedicineDictionary, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[16px] bg-gray-30"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SearchTotalMedicineDictionary, {
                viewModel: props.medicineViewModel
            })
        ]
    });
};
/* harmony default export */ var medicine_dictionary_MedicineDictionaryTemplate = (MedicineDictionaryTemplate);

// EXTERNAL MODULE: ./src/hooks/search/useGetKeywordIntegratedSearchMedicineDictionary.ts
var useGetKeywordIntegratedSearchMedicineDictionary = __webpack_require__(28909);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/hook/useSearchTotalMedicineDictionaryViewModel.ts




var useSearchTotalMedicineDictionaryViewModel = function() {
    var router = (0,useCustomRouter/* default */.Z)().router;
    var queries = router.isReady ? router.query : {
        keyword: "",
        page: "1"
    };
    var _page = queries.page, page = _page === void 0 ? "1" : _page;
    var currentPage = Number(page) || 1;
    var ref = (0,useGetKeywordIntegratedSearchMedicineDictionary/* default */.Z)({
        keyword: undefined,
        enabled: true,
        limit: 10,
        page: currentPage
    }), keywordSearchMedicineDictionary = ref.keywordSearchMedicineDictionary, totalPage = ref.totalPage;
    var medicineDictionaryItems = (keywordSearchMedicineDictionary === null || keywordSearchMedicineDictionary === void 0 ? void 0 : keywordSearchMedicineDictionary.elements) || [];
    var paginationBaseUrl = common/* ROUTES.MEDICINE_DICTIONARY.HOME.path */.Z6.MEDICINE_DICTIONARY.HOME.path;
    var onClickMedicineDictionary = function(medicineDictionary) {
        return function() {
            router.push((0,util/* createMedicineDictionaryDetailUrl */.at)(medicineDictionary));
        };
    };
    return {
        medicineDictionaryItems: medicineDictionaryItems,
        currentPage: currentPage,
        totalPage: totalPage,
        queries: queries,
        paginationBaseUrl: paginationBaseUrl,
        onClickMedicineDictionary: onClickMedicineDictionary
    };
};
/* harmony default export */ var hook_useSearchTotalMedicineDictionaryViewModel = (useSearchTotalMedicineDictionaryViewModel);

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/hooks/medicine-dictionary/useMedicineDictionaryViewModel.ts



var useMedicineDictionaryViewModel = function() {
    var router = (0,useCustomRouter/* default */.Z)().router;
    var queries = router.isReady ? router.query : {
        keyword: "",
        page: "1"
    };
    var searchInputRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(queries.keyword || ""), keyword = ref[0], setKeyword = ref[1];
    var handleSubmit = function() {
        var ref;
        var searchKeyword = ((ref = searchInputRef.current) === null || ref === void 0 ? void 0 : ref.value) || "";
        if (searchKeyword) {
            router.push({
                pathname: common/* ROUTES.MEDICINE_DICTIONARY.SEARCH.path */.Z6.MEDICINE_DICTIONARY.SEARCH.path,
                query: {
                    keyword: searchKeyword
                }
            });
        }
    };
    var handleResetSearchKeyword = function() {
        if (searchInputRef.current) {
            searchInputRef.current.value = "";
        }
        router.push({
            pathname: common/* ROUTES.MEDICINE_DICTIONARY.HOME.path */.Z6.MEDICINE_DICTIONARY.HOME.path,
            query: {}
        });
    };
    var handleBackButtonClick = function() {
        router.back();
    };
    var handleChangeSearchKeyword = function(e) {
        setKeyword(e.target.value);
    };
    return {
        queries: queries,
        keyword: keyword,
        searchInputRef: searchInputRef,
        handleSubmit: handleSubmit,
        handleResetSearchKeyword: handleResetSearchKeyword,
        handleBackButtonClick: handleBackButtonClick,
        handleChangeSearchKeyword: handleChangeSearchKeyword
    };
};
/* harmony default export */ var medicine_dictionary_useMedicineDictionaryViewModel = (useMedicineDictionaryViewModel);

// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/medicine-dictionary/index.tsx
// PageDescription: 의약품 사전 홈페이지








var createMedicineDictionaryLdJson = function(medicines, page) {
    return [
        {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": "".concat("https://doctornow.co.kr").concat(common/* ROUTES.MEDICINE_DICTIONARY.HOME.path */.Z6.MEDICINE_DICTIONARY.HOME.path).concat((0,url/* addQueryString */.sC)({
                page: page
            })),
            url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.MEDICINE_DICTIONARY.HOME.path */.Z6.MEDICINE_DICTIONARY.HOME.path).concat((0,url/* addQueryString */.sC)({
                page: page
            })),
            name: "닥터나우 의약품 사전 | 약의 효능부터 복용법, 부작용까지 - 닥터나우",
            description: "어떤 약인지 궁금하다면? 닥터나우 의약품 사전에서 효능\xb7효과, 복용법, 주의사항, 부작용까지 한눈에 확인하세요.",
            publisher: {
                "@type": "Organization",
                name: "닥터나우",
                url: "https://doctornow.co.kr",
                logo: {
                    "@type": "ImageObject",
                    url: "https://media.doctornow.co.kr/og-main.png"
                },
                contactPoint: [
                    {
                        "@type": "ContactPoint",
                        contactType: "customer service",
                        email: "contact@doctornow.co.kr"
                    }, 
                ]
            }
        },
        {
            "@context": "https://schema.org",
            "@type": "ItemList",
            "@id": "".concat("https://doctornow.co.kr").concat(common/* ROUTES.MEDICINE_DICTIONARY.HOME.path */.Z6.MEDICINE_DICTIONARY.HOME.path).concat((0,url/* addQueryString */.sC)({
                page: page
            }), "#itemList"),
            name: "닥터나우 의약품 사전 | 약의 효능부터 복용법, 부작용까지 - 닥터나우",
            description: "어떤 약인지 궁금하다면? 닥터나우 의약품 사전에서 효능\xb7효과, 복용법, 주의사항, 부작용까지 한눈에 확인하세요.",
            numberOfItems: medicines.length,
            itemListOrder: "https://schema.org/ItemListOrderAscending",
            itemListElement: medicines.map(function(medicine, index) {
                return {
                    "@type": "ListItem",
                    position: index + 1,
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.MEDICINE_DICTIONARY.DETAIL.path */.Z6.MEDICINE_DICTIONARY.DETAIL.path, "/").concat(medicine.getPublicId()),
                    name: medicine.getBasicInfoName()
                };
            })
        },
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "닥터나우",
            url: "https://doctornow.co.kr",
            logo: "https://media.doctornow.co.kr/og-main.png",
            contactPoint: [
                {
                    "@type": "ContactPoint",
                    contactType: "customer service",
                    email: "contact@doctornow.co.kr"
                }, 
            ]
        }, 
    ];
};
var MedicineDictionaryPage = function(param) {
    var client = param.client;
    var viewModel = medicine_dictionary_useMedicineDictionaryViewModel();
    var medicineViewModel = hook_useSearchTotalMedicineDictionaryViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(createMedicineDictionaryLdJson(medicineViewModel.medicineDictionaryItems, medicineViewModel.currentPage))
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "닥터나우 의약품 사전 | 약의 효능부터 복용법, 부작용까지 - 닥터나우",
                description: "어떤 약인지 궁금하다면? 닥터나우 의약품 사전에서 효능\xb7효과, 복용법, 주의사항, 부작용까지 한눈에 확인하세요.",
                additionalMetaTags: [
                    {
                        name: "keywords",
                        content: "의약품 사전, 약 효능, 약 부작용, 복용법, 약 정보"
                    }, 
                ],
                openGraph: {
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.MEDICINE_DICTIONARY.HOME.path */.Z6.MEDICINE_DICTIONARY.HOME.path).concat((0,url/* addQueryString */.sC)(viewModel.queries))
                },
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.MEDICINE_DICTIONARY.HOME.path */.Z6.MEDICINE_DICTIONARY.HOME.path).concat((0,url/* addQueryString */.sC)(viewModel.queries))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(medicine_dictionary_MedicineDictionaryTemplate, {
                viewModel: viewModel,
                client: client,
                medicineViewModel: medicineViewModel
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var medicine_dictionary = (MedicineDictionaryPage);


/***/ }),

/***/ 83464:
/***/ (function(module) {

"use strict";
module.exports = cacheable-lookup;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7041,6492,9097,1498,1312,8391,2271,1330,1121,9774,2888,179], function() { return __webpack_exec__(54931); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);